exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1R6F {\n    margin-right: 5px;\n    font-size: 12px;\n    text-align: right;\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n    transition: height 0.2s ease-in, opacity 0s ease-in 0.2s;\n}\n\n._1R6F:first-letter {\n    text-transform: uppercase;\n}\n\n.X9Bh {\n    height: 20px;\n    opacity: 1;\n}\n\n._1Q1v {\n    text-align: left;\n    margin-right: 0;\n    margin-left: 59px;\n}\n", ""]);

// exports
exports.locals = {
	"created": "_1R6F",
	"visible": "X9Bh",
	"alt": "_1Q1v"
};